import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MeasurementUnitsLayer from "../components/MeasurementUnitsLayer";

const MeasurementUnitsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Units of Measure't>

        {/* MeasurementUnitsLayer */}
        <MeasurementUnitsLayer />
      </MasterLayout>
    </>
  );
};

export default MeasurementUnitsPage;
